<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>Thiết lập tham số báo cáo</strong>
                    </div>
                    <b-form @submit.prevent="save" style="min-height: 500px">
                        <b-row>
                            <b-col md="4">
                                <b-form-group label="Danh sách cấp đơn vị"
                                              label-for="unitLevelId">
                                    <select2 v-model="unitLevelId" :options="unitLevels"></select2>
                                </b-form-group>
                            </b-col>
                            <b-col md="8">
                                <b-form-group :label="'Cấp đơn vị ' + selectedUnitLevel.text.toLowerCase()" v-if="selectedUnitLevel">
                                    <b-form-checkbox-group v-model="reportTypes" class="checkbox-group">
                                        <b-row>
                                            <b-col>
                                                <b-form-checkbox v-for="reporType in allReportTypes" :key="reporType.id" :value="reporType.id" class="col-md-6">{{ reporType.text }}</b-form-checkbox>
                                            </b-col>
                                        </b-row>
                                    </b-form-checkbox-group>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row v-if="isBTCUser">
                            <b-col md="8" offset="4">
                                <b-button type="submit" variant="primary">Lưu</b-button>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import { mixins } from '@/shared/mixins'

    export default {
        name: 'CreateReportParameter',
        mixins: [mixins],
        data() {
            return {
                unitLevelId: 1,
                reportTypes: []
            }
        },
        computed: {
            ...mapState({
                unitLevels: (state, getters) => state.common.unitLevels,
                allReportTypes: (state, getters) => state.common.listReportSyncTypes
            }),
            selectedUnitLevel() {
                var vm = this;
                return this.unitLevels.find(x => x.id == vm.unitLevelId);
            }
        },
        created() {

        },
        methods: {
            save() {
                var vm = this;
                this.$services.put(`system-parameters/reports/${this.unitLevelId}`, this.reportTypes).done((response) => {
                    vm.$toastr.s('Cập nhật tham số báo cáo thành công');
                });
            },
            loadReportTypes() {
                var vm = this;
                if (this.unitLevelId) {
                    this.$services.get(`system-parameters/reports/${this.unitLevelId}`).done((response) => {
                        vm.reportTypes = response;
                    });
                } else {
                    vm.reportTypes = [];
                }
            }
        },
        watch: {
            unitLevelId() {
                this.loadReportTypes();
            }
        }
    }
</script>
<style scoped>
</style>
